import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TournamentCardComponent } from './tournament-card/tournament-card.component';
import {
  ButtonModule,
  ChipsModule,
  DataSliderModule,
  DropdownModule,
  ProgressModule, ShareModule,
  SvgIconModule,
  TextFieldModule,
  UtilsModule
} from '@mtgame/ui';
import { TournamentEventsModule } from '../../shared/tournament-events/tournament-events.module';
import { ROUTES } from './league.routes';
import { LeagueRootComponent } from './league-root.component';
import { LeagueMediaComponent } from './league-media/league-media.component';
import { TournamentMediaModule } from '../../shared/tournament-media/tournament-media.module';
import { LeagueTournamentsComponent } from './league-tournaments/league-tournaments.component';
import { LeagueNewsDetailComponent } from './league-news-detail/league-news-detail.component';
import { LeagueAboutComponent } from './league-about/league-about.component';
import { LeagueContactsComponent } from './league-contacts/league-contacts.component';
import { LeagueMediaDetailComponent } from './league-media/league-media-detail.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LeagueTournamentCardComponent } from './league-tournaments/league-tournament-card/league-tournament-card.component';
import { LeagueNewsListComponent } from './league-news-list/league-news-list.component';
import { SharedModule } from '@shared/shared.module';
import { LeagueVideoListComponent } from './league-video-list/league-video-list.component';
import { LeagueVideoDetailComponent } from './league-video-detail/league-video-detail.component';
import { LeagueDocumentsComponent } from './league-documents/league-documents.component';
import { TournamentWidgetModule } from '../../shared/tournament-widget/tournament-widget.module';
import {
  DivisionStandingsComponent
} from './league-tournaments/league-tournament-card/division-standings/division-standings.component';
import {
  TournamentStandingsComponent
} from './league-tournaments/league-tournament-card/tournament-standings/tournament-standings.component';
import { TournamentStageWidgetModule } from '../../shared/tournament-stage-widget/tournament-stage-widget.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    UtilsModule,

    // UI Kit
    ButtonModule,
    SvgIconModule,
    ChipsModule,
    DataSliderModule,
    TournamentEventsModule,
    ProgressModule,
    TournamentMediaModule,
    TextFieldModule,
    DropdownModule,
    ReactiveFormsModule,
    ShareModule,
    SharedModule,
    TournamentWidgetModule,
    TournamentStageWidgetModule,
  ],
  declarations: [
    LeagueRootComponent,
    LeagueNewsDetailComponent,
    TournamentCardComponent,
    LeagueMediaComponent,
    LeagueTournamentsComponent,
    LeagueTournamentCardComponent,
    LeagueAboutComponent,
    LeagueContactsComponent,
    LeagueDocumentsComponent,
    LeagueMediaDetailComponent,
    LeagueNewsListComponent,
    LeagueVideoListComponent,
    LeagueVideoDetailComponent,
    DivisionStandingsComponent,
    TournamentStandingsComponent,
  ]
})
export class LeagueModule {}
